

import React, { useEffect, useState } from "react"
import {
  Button,
  Input,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Image,
  Alert,
  User,
} from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css" //react toastify css

import { linksUrl } from "../constants/enum.js"
import { setLogin } from "../state/authSlice.jsx"
import { usePostLogin } from "../api/reactQueryCustomHooks.jsx"
import { useQueryClient } from "@tanstack/react-query"
import { resetCompCode } from "../state/companySlice.jsx"
import { isMobile } from "react-device-detect"


export default function App() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [isVisible, setIsVisible] = useState(false)
  const toggleVisibility = () => setIsVisible(!isVisible)


  const [formData, setFormData] = useState({
    clientCode: "",
    loginName: "",
    password: "",
  })

  const [errors, setErrors] = useState({})

  const resetValues = () => {
    setFormData({
      clientCode: "",
      loginName: "",
      password: "",
    })
  }

  const onSuccessTasks = (data) => {

    if (data && Object.keys(data)?.length > 0) {
      
      navigate(linksUrl.companies)
      dispatch(
        setLogin({
          user: data.user,
          token: data.accessToken,
          menu: { appMenu: data.appMenu, userMenu: data.userMenu },
          isAuthenticated: true,
          userSetting: data.userSetting
        })
      )
      dispatch(resetCompCode())
      queryClient.removeQueries()
    }
    else {
      toast.error("Incorrect Details...", {
        "position": "top-center"
      })
    }


  }

  const { isPending, mutate: login } = usePostLogin({
    url: "/user/login",
    queryKey: "auth",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const validateForm = () => {
    let msg = ''
    if (formData.clientCode.trim() === "") {
      msg = " Client Code required , "
    }
    if (formData.loginName.trim() === "") {
      msg += " Login Name required , "
    }
    if (formData.password.trim() === "") {
      msg += " Password required , "
    }
    return msg
  }


  const handleSubmit = (e) => {
    e.preventDefault()
    let errorMsg = validateForm()


    if (errorMsg.trim() == "") {
      login({
        data: {
          Client_Code: formData.clientCode,
          LoginName: formData.loginName,
          Password: formData.password,
        },
      })
    }
    else {
      toast.error(errorMsg, { "position": "top-center" })
    }

  }

  return (
    <div>
      <ToastContainer />
      <div className={`${isMobile ? "bg-white" : "bg-gradient-to-tr from-gray-50 to-sky-50"} h-screen`}>
        <div className="bg-sky-900 text-white   text-center uppercase text-xl   tracking-widest p-3">
          {/* <img src="IITS_Logo.png"  alt="INTITS"  ></img><div className="mx-auto">WINAPP</div>  flex items-center justify-start */}
          WINAPP
        </div>

        <div className={` ${isMobile ? " py-0 px-0" : "py-6 px-1"} "min-h-screen flex flex-col items-center justify-start  text-baseline"`}>
          <div className={`${isMobile ? " border-0" : "border-1 shadow-xl shadow-gray-300"} " max-w-md w-full  py-8 px-6  
          border-sky-500 border-x-gray-100 
           bg-gradient-to-tr from-gray-50 to-gray-50"`}>
            {/* //bg-custome-login-box-color">  border-radius */}
            <div className="bg-gradient-to-tr from-sy-50 to-sy-600 mx-auto  
           border-b-2 border-gray-300 border-x-pink-200">
              <User
                description={(
                  <h1 className="text-2xl font-bold w-full  tracking-widest mx-12 dark:text-white 
          text-center  text-sky-800">
                    {/* text-custom-text-primary */}
                    LOGIN
                  </h1>
                )}
                avatarProps={{
                  src: "IITS_Logo.png",
                  size: "lg",
                  radius: "none",
                  isBordered: false,
                  // 
                }}

              />
            </div>
            <form onSubmit={handleSubmit} autoComplete='off'>
              <div className="!mt-10">
                <Input
                  isRequired
                  type="text"
                  label="Client Code"
                  placeholder=" "
                  size="md"
                  labelPlacement="outside"
                  name="clientCode"
                  value={formData.clientCode}
                  variant="flat"
                  radius="none"
                  onChange={handleChange}
                  classNames={{
                    base: "border-1 border-orange-200 ",
                    label: "font-semibold"
                  }}
                  isDisabled={isPending}
                />
              </div>
              <div className="!mt-10">
                <Input
                  isRequired
                  type="text"
                  label="Login Name"
                  placeholder=" "
                  labelPlacement="outside"
                  name="loginName"
                  radius="none"
                  value={formData.loginName}
                  onChange={handleChange}
                  variant="flat"
                  classNames={{
                    base: "border-1 border-orange-200 ",
                    label: "font-semibold"
                  }}
                  isDisabled={isPending}
                  size="md"

                />
              </div>
              <div className="!mt-10">
                <Input
                  isRequired
                  label="Password"
                  labelPlacement="outside"
                  placeholder="Enter your password"
                  name="password"
                  size="md"
                  value={formData.password}
                  onChange={handleChange}
                  isDisabled={isPending}
                  radius="none"
                  variant="flat"
                  classNames={{
                    base: "border-1 border-orange-200 ",
                    label: "font-semibold"
                  }}
                  endContent={
                    <button
                      className="focus:outline-none"
                      size="sm"
                      type="button"
                      variant="light"
                      onClick={toggleVisibility}
                    >
                      {isVisible ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </button>
                  }
                  type={isVisible ? "text" : "password"}

                />
              </div>

              <div className="!mt-10 text-center">

                <Button color="primary" variant="bordered" radius="none"

                  className="  text-md uppercase text-white   tracking-widest  w-full  border-1 border-gray-100
                  bg-gradient-to-t from-sky-800 to-sky-600" type="submit" isLoading={isPending}>
                  Login
                </Button>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  )
}
